import { FC } from 'react';
import { allCurrencies } from 'lib/constants';
import { MORE } from 'constants/shared/routes';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import AccountDetails from '../presentational/AccountDetails';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import useTranslate from 'lib/languages/useTranslate';
import { useGetAccountQuery } from 'lib/services';

const AccountDetailsContainer: FC = () => {
    const translate = useTranslate('accountDetails');
    const { data, isFetching, error } = useGetAccountQuery();

    const getCurrencyFlag = () => {
        if (!data) return { flag: '' };

        const currencyMatch = allCurrencies.find(
            currency =>
                data.clearedBalanceCurrencyCode === currency.currency_code,
        );

        return {
            flag: currencyMatch?.flag || '',
        };
    };

    return (
        <PageContainer className="more-account-details-container">
            <SectionTitle title={translate('titleText')} backRoute={MORE} />
            <DataCheck
                data={data}
                isLoading={isFetching}
                error={error}
                noDataMessage={translate('noDataMessage')}
            >
                {data && (
                    <AccountDetails data={data} flag={getCurrencyFlag()} />
                )}
            </DataCheck>
        </PageContainer>
    );
};

export default AccountDetailsContainer;
